import { render, staticRenderFns } from "./truth_pc.vue?vue&type=template&id=30a348ce&scoped=true&"
import script from "./truth_pc.vue?vue&type=script&lang=js&"
export * from "./truth_pc.vue?vue&type=script&lang=js&"
import style0 from "./truth_pc.vue?vue&type=style&index=0&id=30a348ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a348ce",
  null
  
)

export default component.exports